import React from "react";
import { Layout as AntdLayout, theme } from "antd";
import ReduxRedirect from "../../Common/ReduxRedirect";
import LanguageSwitcher from "../../Common/LanguageSwitcher";

import styles from "./index.module.scss";

interface SimpleProps {
  children: React.ReactNode;
}

export default function SimpleLayout({
  children,
}: SimpleProps): React.ReactNode {
  const {
    token: { colorPrimaryBg },
  } = theme.useToken();

  return (
    <>
      <ReduxRedirect />
      <AntdLayout>
        {/* The auth screens sit on a tint of the primary rather than the app's
            neutral layout grey. Inline because SCSS cannot read a token. */}
        <AntdLayout.Content
          className={styles.content}
          style={{ background: colorPrimaryBg }}
        >
          {children}
          <div className={styles.languageSwitcher}>
            <LanguageSwitcher />
          </div>
        </AntdLayout.Content>
      </AntdLayout>
    </>
  );
}
